import { createFileRoute } from "@tanstack/react-router";
import { seo } from "~/utils/seo";
import { ShaderViewport } from "~/components/shaders/ShaderViewport";

export const Route = createFileRoute("/shaders")({
  loader: () => ({ title: "Shader Lab" }),
  head: () => ({
    meta: seo({ title: "Shader Lab", noindex: true }),
  }),
  component: () => (
    <div className="flex min-h-screen items-center justify-center bg-[#1A181D] py-12">
      <ShaderViewport />
    </div>
  ),
});
